<template>
  <div
    v-if="group !== 'ungrouped'"
    class="mb-2 flex cursor-pointer flex-row py-2 pl-2 text-xs text-neutral-500 hover:text-primary-500"
    :class="{
      'active-menu-item': !isGroupOpen && isActiveRouteInGroup
    }"
    @click="doToggleGroup"
  >
    <h3 class="flex-1">
      {{ t(group) }}
    </h3>
    <div class="flex flex-col justify-center pr-4">
      <font-awesome-icon :icon="isGroupOpen ? ['far', 'chevron-down'] : ['far', 'chevron-up']" />
    </div>
  </div>
  <div v-if="isGroupOpen" class="flex flex-col gap-1">
    <NavigationSideBarItem
      v-for="(item, i) in groupItems"
      :key="`${item.name}-${i}`"
      v-permission="{ ids: item.permissionIds, check: item.permissionCheck }"
      :name="item.name"
      :icon="item.icon"
      :to="item.to"
    />
  </div>
</template>

<script lang="ts" setup>
import { vPermission } from '@infuse/iam/permission/directives';
import { MenuItem } from '@infuse/ui/domain';
import { useI18n } from 'vue-i18n';
import NavigationSideBarItem from './NavigationSideBarItem.vue';
import { useNavigationStore } from '@infuse/ui/stores';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const navigationStore = useNavigationStore();
const route = useRoute();

const { t } = useI18n();

interface Props {
  group: string;
  groupItems: MenuItem[];
}

const props = defineProps<Props>();

const isGroupOpen = computed(() => !navigationStore.groupClosed.includes(props.group));
const isActiveRouteInGroup = computed(() =>
  props.groupItems.some((item) => route.matched.some((matchedRoute) => matchedRoute.path === item.to))
);

function doToggleGroup() {
  navigationStore.toggleGroup(props.group);
}
</script>
